import React from 'react'
import styled from 'styled-components'

import { Inline, MyOptionType, Select, SelectProps, Text } from '@procsea/design-system'

import { Label } from 'src/types'

import { retrieveEntityFromValue } from '../fields.utils'
import useLabelOptions from './useLabelOptions'

export const ImageContainer = styled.div`
  display: flex;
  flex: 0 0 auto;
  height: 1.6em;
  width: 1.6em;
`

export const Image = styled.img`
  margin: auto;
  max-height: 100%;
  max-width: 100%;
`

export interface LabelSelectProps<IsMulti extends boolean> {
  'data-e2e'?: string
  errorMessage?: string
  fluid?: boolean
  label?: string
  multiple?: IsMulti
  name?: string
  onChange?: SelectProps<Label, IsMulti>['onChange']
  value?: SelectProps<Id, IsMulti>['value']
}

const formatOptionWithLogo = ({ label, value }: MyOptionType<Label>) => (
  <Inline alignment="center" spacing="small" noWrap>
    <ImageContainer>
      <Image alt={label} src={value.logo} />
    </ImageContainer>
    <Text>{label}</Text>
  </Inline>
)

const LabelSelect = <IsMulti extends boolean>({
  'data-e2e': dataE2e = 'labels-field',
  errorMessage,
  fluid,
  label,
  multiple,
  name,
  onChange,
  value,
}: LabelSelectProps<IsMulti>) => {
  const { labelOptions, isInitialLoading } = useLabelOptions()

  const innerValue = retrieveEntityFromValue({
    equalityKey: 'id',
    value,
    options: labelOptions,
    multiple,
  }) as SelectProps<Label, IsMulti>['value']

  return (
    <Select<Label, IsMulti>
      data-e2e={dataE2e}
      disabled={!labelOptions || labelOptions.length === 0}
      errorMessage={errorMessage}
      fluid={fluid}
      formatOptionLabel={formatOptionWithLogo}
      formatValueLabel={formatOptionWithLogo}
      isLoading={isInitialLoading}
      label={label}
      minWidth="8rem"
      multiple={multiple}
      name={name}
      onChange={onChange}
      options={labelOptions || []}
      placeholder={gettext('Labels')}
      value={innerValue}
    />
  )
}

export default LabelSelect
